    <template>
        <div>
            <b-modal id="modal-comments" scrollable size="md" hide-footer :title="'COMMENTS FOR ('+item_comments_invoice_id+')'">
                <ItemComments :viewdata="{invoice_id: item_comments_invoice_id, itemid: item_comments_itemid, username: packet.userDetails.username}" />
            </b-modal>

            <div style="width: 100%;">
                <div>
                    <div class="d-flex flex-wrap" style="gap: 7px;">
                        <b-alert variant="secondary" show style="display: inline-block; vertical-align: top;">
                            <div v-if="this.packet.userDetails.properties && !this.packet.userDetails.properties.location_id" style="display: inline-block; vertical-align: top;">
                                <b-form-select size="sm" :options="get_locations()" v-model="drop_location">
                                    <template #first>
                                        <b-form-select-option :value="null" disabled>-- COMING TO --</b-form-select-option>
                                    </template>
                                </b-form-select>
                            </div>

                            <div style="display: inline-block; vertical-align: top;">
                                <b-button variant="success" style="display: inline-block;" size="sm" @click="fetch_init2">SEARCH</b-button>
                            </div>
                        </b-alert>

                        <!-- Date, Driver, Status, Pick From, Delivery Location and Order Type Filters -->
                        <div
                          v-if="isMobile && items.length > 0"
                          class="d-flex justify-content-between align-items-center mb-2 px-1"
                        >
                          <b-button
                            size="sm"
                            variant="outline-primary"
                            @click="filtersVisible = !filtersVisible"
                          >
                            <b-icon-funnel-fill class="mr-1"></b-icon-funnel-fill>
                            {{ filtersVisible ? 'Hide Filters' : 'Show Filters' }}
                          </b-button>
                        </div>

                        <b-collapse :visible="!isMobile || filtersVisible" class="mb-2">
                          <b-alert
                            variant="primary"
                            show
                            style="display: flex; flex-wrap: wrap; gap: 7px; padding: 13px;"
                            v-if="items.length > 0"
                          >
                            <div style="display: inline-block; vertical-align: top;">
                              <b-form-select
                                v-model="selected_date"
                                :options="available_dates"
                                size="sm"
                                style="width: 180px;"
                              >
                                <template #first>
                                  <b-form-select-option :value="null" disabled>-- SELECT DATE --</b-form-select-option>
                                </template>
                              </b-form-select>
                            </div>

                            <div style="display: inline-block; vertical-align: top;">
                              <b-form-select
                                v-model="selected_delivery_location"
                                :options="available_delivery_locations"
                                size="sm"
                                style="width: 180px;"
                              >
                                <template #first>
                                  <b-form-select-option :value="null" disabled>-- DELIVERY LOCATION --</b-form-select-option>
                                </template>
                              </b-form-select>
                            </div>

                            <div style="display: inline-block; vertical-align: top;">
                              <b-form-select
                                v-model="selected_driver"
                                :options="available_drivers"
                                size="sm"
                                style="width: 180px;"
                              >
                                <template #first>
                                  <b-form-select-option :value="null" disabled>-- SELECT DRIVER --</b-form-select-option>
                                </template>
                              </b-form-select>
                            </div>

                            <div style="display: inline-block; vertical-align: top;">
                              <b-form-select
                                v-model="selected_status"
                                :options="status_options"
                                size="sm"
                                style="width: 150px;"
                              >
                                <template #first>
                                  <b-form-select-option :value="null" disabled>-- STATUS --</b-form-select-option>
                                </template>
                              </b-form-select>
                            </div>

                            <div style="display: inline-block; vertical-align: top;">
                              <b-form-select
                                v-model="selected_pick_from"
                                :options="available_pick_from_locations"
                                size="sm"
                                style="width: 180px;"
                              >
                                <template #first>
                                  <b-form-select-option :value="null" disabled>-- ITEM PICK FROM --</b-form-select-option>
                                </template>
                              </b-form-select>
                            </div>

                            <div style="display: inline-block; vertical-align: top;">
                              <b-form-select
                                v-model="selected_delivery_location"
                                :options="available_delivery_locations"
                                size="sm"
                                style="width: 180px;"
                              >
                                <template #first>
                                  <b-form-select-option :value="null" disabled>-- DELIVERY LOCATION --</b-form-select-option>
                                </template>
                              </b-form-select>
                            </div>

                            <div style="display: inline-block; vertical-align: top;">
                              <b-form-select
                                v-model="selected_order_type"
                                :options="available_order_types"
                                size="sm"
                                style="width: 150px;"
                              >
                                <template #first>
                                  <b-form-select-option :value="null" disabled>-- ORDER TYPE --</b-form-select-option>
                                </template>
                              </b-form-select>
                            </div>
                          </b-alert>
                        </b-collapse>
                    </div>
                </div>
            </div>

            <div style="width: 100%; padding: 5px; min-height: 200px;">
                <div>
                    <div v-if="items_being_loaded == true">
                        <loading
                        :active="true"
                        :can-cancel="false"
                        :is-full-page="false">
                        </loading>
                    </div>
                    <div v-else>
                        <div v-if="filtered.length > 0" class="diver">
                            <table style="width: 100%;">
                                <thead>
                                    <tr>
                                        <td class="srr" style="width: 120px;" @click="sortby('invoice_id')">
                                            INVOICE #
                                        </td>
                                        <td class="srr" style="width: 100px;">
                                            DELIVERY DATE
                                        </td>
                                        <td class="srr" style="width: 100px;" @click="sortby('product_sku')">
                                            PRD SKU
                                        </td>
                                        <td class="srr" style="width: 250px;" @click="sortby('product_name')">
                                            PRD NAME
                                        </td>
                                        <td class="srr" style="width: 120px;" @click="sortby('order_type')">
                                            ORDER TYPE
                                        </td>
                                        <td class="srr" style="width: 50px;" @click="sortby('quantity')">
                                            QTY
                                        </td>
                                        <td class="srr" style="width: 250px;" @click="sortby('locsub')">
                                            ITEM PICK FROM
                                        </td>
                                        <td class="srr" style="width: 250px;" @click="sortby('ship_locsub')">
                                            DROP LOC
                                        </td>
                                        <td class="srr" style="width: 250px;" @click="sortby('drop_locsub')">
                                            DELIVERY LOC
                                        </td>
                                        <td class="srr" style="width:80px;" @click="sortby('pickup_truck')">
                                            PICKUP TRUCK
                                        </td>
                                        <td class="srr" style="width:230px;" @click="sortby('state')">
                                            STATUS
                                        </td>
                                        <td class="srr" style="width:80px;">
                                            ACTION
                                        </td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item,idx in filtered" v-bind:key="idx">
                                        <td class="srrv">
                                            {{ item.invoice_id }}
                                        </td>
                                        <td class="srrv">
                                            {{ item.delivery_date }}
                                        </td>
                                        <td class="srrv">
                                            {{ item.product_sku }}
                                        </td>
                                        <td class="srrv">
                                            {{ item.product_name }}
                                        </td>
                                        <td class="srrv">
                                            <div v-if="item.order_type == 'home_delivery'">
                                                <b-alert show variant="primary" style="padding: 2px; font-size: 11px; text-align: center;">HOME DELIVERY</b-alert>
                                            </div>
                                            <div v-else-if="item.order_type == 'store_pickup'">
                                                <b-alert show variant="warning" style="padding: 2px; font-size: 11px; text-align: center;">STORE PICKUP</b-alert>
                                            </div>
                                            <div v-else-if="item.incoming_type == 'STORE_TRANSFER_ORDER'">
                                                <b-alert show variant="info" style="padding: 2px; font-size: 11px; text-align: center;">STORE TRANSFER</b-alert>
                                            </div>
                                             <div v-else-if="item.incoming_type == 'DAMAGE_ORDER'">
                                                <b-alert show variant="secondary" style="padding: 2px; font-size: 11px; text-align: center;">DAMAGE ORDER</b-alert>
                                            </div>
                                            <div v-else>
                                                {{item.order_type}}
                                            </div>
                                        </td>
                                        <td class="srrv">
                                            {{ item.quantity }}
                                        </td>
                                        <td class="srrv">
                                            <span v-if="item.incoming_type == 'CUSTOMER_ORDER'">
                                                {{item.locsub === "0" ? "MECCA WHOLESALE" : packet.locsubsdict[item.original_locsub]}}
                                            </span>
                                            <span v-else-if="item.incoming_type == 'STORE_TRANSFER_ORDER'">
                                                {{packet.locsubsdict[item.ship_locsub]}}
                                            </span>
                                            <span v-else-if="item.incoming_type == 'DAMAGE_ORDER'">
                                                {{packet.locsubsdict[item.locsub] || item.locsub}}
                                            </span>
                                        </td>
                                        <td class="srrv">
                                            <span v-if="item.incoming_type == 'CUSTOMER_ORDER'">
                                                {{packet.locsubsdict[item.ship_locsub]}}
                                            </span>
                                            <span v-else-if="item.incoming_type == 'STORE_TRANSFER_ORDER'">
                                                <!-- For transfer orders, show the reserved location (where it's coming from) -->
                                                {{packet.locsubsdict[item.original_locsub]}}
                                            </span>
                                             <span v-else-if="item.incoming_type == 'DAMAGE_ORDER'">
                                                {{packet.locsubsdict[item.ship_locsub] || item.ship_locsub}}
                                            </span>
                                        </td>
                                        <td class="srrv">
                                            <span v-if="item.incoming_type == 'CUSTOMER_ORDER'">
                                                {{packet.locsubsdict[item.drop_locsub]}}
                                            </span>
                                            <span v-else-if="item.incoming_type == 'STORE_TRANSFER_ORDER'">
                                                {{packet.locsubsdict[item.drop_locsub]}}
                                            </span>
                                            <span v-else-if="item.incoming_type == 'DAMAGE_ORDER'">
                                                {{packet.locsubsdict[item.drop_locsub] || item.drop_locsub}}
                                            </span>
                                        </td>
                                        <td class="srrv">
                                            <span v-if="item.incoming_type == 'CUSTOMER_ORDER'">
                                                {{packet.trucksdict[item.pickup_truck]}}
                                            </span>
                                            <span v-else-if="item.incoming_type == 'STORE_TRANSFER_ORDER'">
                                                N/A
                                            </span>
                                             <span v-else-if="item.incoming_type == 'DAMAGE_ORDER'">
                                                    N/A
                                                </span>
                                        </td>
                                        <td class="srrv">
                                    <b-form-select
                                            size="sm"
                                            :style="{width: '210px', textAlign: 'center'}"
                                            :options="getFilteredStates(item)"
                                            v-model="item.state"
                                            v-on:change="update_invoice_item_state(item)"
                                            :disabled="item.state !== 30 && packet.locsubsdict[item.locsub] == 'OUT OF STOCK | OUT OF STOCK'"
                                        ></b-form-select>
                                        </td>
                                        <td class="srrv hidden-print">
                                            <button @click="show_comments(item)">CMNT</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div v-else-if="items.length > 0 && filtered.length === 0">
                            <b-alert variant="info" show>
                                No items match the selected filters.
                            </b-alert>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </template>

    <script>
        import DatePicker from 'vue2-datepicker';
        import moment from 'moment'
        import mappings from '@/utilities/mappings'
        import flatPickr from 'vue-flatpickr-component';
        import 'flatpickr/dist/flatpickr.css';
        import Requestor from '@/utilities/Requestor';
        import Loading from 'vue-loading-overlay';
        import 'vue-loading-overlay/dist/vue-loading.css';
        import { BIconFunnelFill } from 'bootstrap-vue'

        import ItemComments from '@/components/importables/ItemComments'
    import { text } from 'd3';

        export default {
            name: "Incoming",
            components: {flatPickr, Loading, ItemComments, DatePicker},
            data: function(){
                let out = {
                    items: [],
                    date_range: [],
                    picked_date_range: null,
                    dates: [],
                    drop_location: null,
                    active_date:null,
                    years: [
                        {value: 2022, text: 2022},
                        {value: 2023, text: 2023},
                        {value: 2024, text: 2024},
                        {value: 2025, text: 2025},
                        {value: 2026, text: 2026},
                        {value: 2027, text: 2027},
                        {value: 2028, text: 2028},
                        {value: 2029, text: 2029},
                        {value: 2030, text: 2030},
                        {value: 2031, text: 2031},
                        {value: 2032, text: 2032},
                        {value: 2033, text: 2033},
                        {value: 2034, text: 2034},
                        {value: 2035, text: 2035},
                    ],
                    months: [
                        {value: 1, text: 1},
                        {value: 2, text: 2},
                        {value: 3, text: 3},
                        {value: 4, text: 4},
                        {value: 5, text: 5},
                        {value: 6, text: 6},
                        {value: 7, text: 7},
                        {value: 8, text: 8},
                        {value: 9, text: 9},
                        {value: 10, text: 10},
                        {value: 11, text: 11},
                        {value: 12, text: 12},
                    ],
                    year: null,
                    month: null,
                    picked_date: null,
                    picked_location_id: null,
                    picked_pickup_truck: null,

                    packet: {},
                    items_being_loaded: false,
                    dates_being_loaded: false,
                    current_date: null,
                    type: 'incoming',
                    locsubs: [],
                    locsub: null,
    states: mappings.states.map(function(d){
        // Create the state options with custom text for specific values
        let stateOption = {...d};

        // Map the text values as requested
        if(d.value == 9) stateOption.text = "RECEIVED FROM WAREHOUSE";
        if(d.value == 10) stateOption.text = "DISPATCHED FOR STORE";
        if(d.value == -10) stateOption.text = "CANT DISPATCHED FOR STORE";

        return stateOption;
    }),
                    states_outgoing_current: mappings.states,
                    states_outgoing_new: mappings.states,
                    states_dict: mappings.states_dict,
                    item_comments_invoice_id: null,
                    item_comments_itemid: null,
                    comments_dict: {},
                    sort_asc: true,
                    trucks: [],
                    incoming_types: [
                        {value: null, text: "ALL"},
                        {value: "CUSTOMER_ORDER", text: "CUSTOMER ORDER"},
                        {value: "STORE_TRANSFER_ORDER", text: "STORE TRANSFER ORDER"},
                    ],
                    picked_incoming_type: null,
                    selected_state: "open",

                    // New filter data
                    selected_date: null,
                    selected_driver: null,
                    selected_status: null,
                    selected_order_type: null,
                    selected_pick_from: null, // New filter for Item Pick From
                    selected_delivery_location: null, // New filter for Delivery Location
                    available_dates: [],
                    available_drivers: [],
                    available_pick_from_locations: [], // Options for Item Pick From filter
                    available_delivery_locations: [], // Options for Delivery Location filter
                    available_order_types: [], // Dynamic order type options
                status_options: [
        {value: null, text: "ALL STATUS"},
        {value: 0, text: "ORDERED"},
        {value: 2, text: "PULLED"},
        {value: -2, text: "CANT PULLED"},
        {value: 3, text: "PICKED FROM WAREHOUSE"},
        {value: -3, text: "CANT PICK FROM WAREHOUSE"},
        {value: 30, text: "DROPPED"},
        {value: -30, text: "CANNOT BE DROPPED"},
        {value: 9, text: "RECEIVED FROM WAREHOUSE"},
        {value: -9, text: "CANT RECEIVED FROM WAREHOUSE"},
        {value: 10, text: "DISPATCHED FOR STORE"},
        {value: -10, text: "CANT DISPATCHED FOR STORE"},
    ],
                    filtersVisible: false,
                    isMobile: false,
                }
                return out;
            },
            computed: {
 filtered: function(){
    let that = this;
    return this.items.filter(function(d){
        // Date filter
        const dateMatch = that.selected_date ? d.delivery_date === that.selected_date : true;

        // Driver filter
        const driverMatch = that.selected_driver ?
            (d.pickup_truck == that.selected_driver || d.truck == that.selected_driver) : true;

        // Status filter
        const statusMatch = that.selected_status !== null ?
            d.state === that.selected_status : true;

        // Order type filter - UPDATED TO INCLUDE DAMAGE ORDER
        const orderTypeMatch = that.selected_order_type ?
            (d.order_type === that.selected_order_type ||
             (that.selected_order_type === 'store_transfer' && d.incoming_type === 'STORE_TRANSFER_ORDER') ||
             (that.selected_order_type === 'damage_order' && d.incoming_type === 'DAMAGE_ORDER')) : true;

        // Item Pick From filter
        const pickFromMatch = that.selected_pick_from !== null ?
            that.getItemPickFromLocation(d) === that.selected_pick_from : true;

        // Delivery Location filter (drop_locsub)
        const deliveryLocationMatch = that.selected_delivery_location !== null ?
            that.getDeliveryLocation(d) === that.selected_delivery_location : true;

        // Location filter - only show items where location_id matches ship_locsub
        const locationMatch = that.allowed_item(d);

        return dateMatch && driverMatch && statusMatch && orderTypeMatch && pickFromMatch && deliveryLocationMatch && locationMatch;
    });
},
            },
            watch: {
                // Watch all filter changes to update available options dynamically
                selected_date: function(newDate) {
                    this.updateAllAvailableOptions();
                },
                selected_driver: function(newDriver) {
                    this.updateAllAvailableOptions();
                },
                selected_status: function(newStatus) {
                    this.updateAllAvailableOptions();
                },
                selected_order_type: function(newOrderType) {
                    this.updateAllAvailableOptions();
                },
                selected_pick_from: function(newPickFrom) {
                    this.updateAllAvailableOptions();
                },
                selected_delivery_location: function(newDeliveryLocation) {
                    this.updateAllAvailableOptions();
                },
                items: function(newItems) {
                    this.updateAllAvailableOptions();
                },
                                selected_delivery_location: function(newDeliveryLocation) {
                    this.updateAllAvailableOptions();
                },
            },
            methods: {
              handleResize() {
                this.isMobile = window.innerWidth < 768;
              },

     getItemPickFromLocation(item) {
    if (item.incoming_type == 'CUSTOMER_ORDER') {
        return item.locsub === "0" ? "MECCA WHOLESALE" : this.packet.locsubsdict[item.original_locsub];
    } else if (item.incoming_type == 'STORE_TRANSFER_ORDER') {
        return this.packet.locsubsdict[item.ship_locsub];
    } else if (item.incoming_type == 'DAMAGE_ORDER') {
        return this.packet.locsubsdict[item.locsub] || item.locsub;
    }
    return "";
},  

getDeliveryLocation(item) {
    if (item.incoming_type == 'CUSTOMER_ORDER') {
        return this.packet.locsubsdict[item.drop_locsub];
    } else if (item.incoming_type == 'STORE_TRANSFER_ORDER') {
        return this.packet.locsubsdict[item.drop_locsub];
    } else if (item.incoming_type == 'DAMAGE_ORDER') {
        return this.packet.locsubsdict[item.drop_locsub] || item.drop_locsub;
    }
    return "";
},
                // Main method to update all available options based on current filters
                updateAllAvailableOptions() {
                    const filteredItems = this.getCurrentlyFilteredItems();
                    this.updateAvailableDates(filteredItems);
                    this.updateAvailableDrivers(filteredItems);
                    this.updateAvailableLocations(filteredItems);
                    this.updateAvailableOrderTypes(filteredItems);
                    this.updateAvailableStatuses(filteredItems);
                },
                // Get items filtered by all current selections
                getCurrentlyFilteredItems() {
                    let that = this;
                    return this.items.filter(function(item) {
                        // Apply all current filters except the one being updated
                        const dateMatch = that.selected_date ? item.delivery_date === that.selected_date : true;
                        const driverMatch = that.selected_driver ?
                            (item.pickup_truck == that.selected_driver || item.truck == that.selected_driver) : true;
                        const statusMatch = that.selected_status !== null ? item.state === that.selected_status : true;
                        const orderTypeMatch = that.selected_order_type ? item.order_type === that.selected_order_type : true;
                        const pickFromMatch = that.selected_pick_from !== null ?
                            that.getItemPickFromLocation(item) === that.selected_pick_from : true;
                        const deliveryLocationMatch = that.selected_delivery_location !== null ?
                            that.getDeliveryLocation(item) === that.selected_delivery_location : true;
                        const locationMatch = that.allowed_item(item);

                        return dateMatch && driverMatch && statusMatch && orderTypeMatch && pickFromMatch && deliveryLocationMatch && locationMatch;
                    });
                },
              updateAvailableDates(filteredItems = null) {
    // Always use the full items array to show ALL available dates
    const itemsToUse = this.items; // Changed from filteredItems || this.items

    const dateCounts = {};
    itemsToUse.forEach(item => {
        if (item.delivery_date) {
            dateCounts[item.delivery_date] = (dateCounts[item.delivery_date] || 0) + 1;
        }
    });

    this.available_dates = [
        { value: null, text: 'All Dates' },
        ...Object.keys(dateCounts).map(date => ({
            value: date,
            text: `${date} (${dateCounts[date]})`
        })).sort((a, b) => new Date(a.value) - new Date(b.value)) // Optional: sort dates chronologically
    ];
},
                updateAvailableDrivers(filteredItems = null) {
                    const itemsToUse = filteredItems || this.items;
                    const driverSet = new Set();

                    itemsToUse.forEach(item => {
                        if (item.pickup_truck && this.packet.trucksdict[item.pickup_truck]) {
                            driverSet.add(item.pickup_truck);
                        }
                        if (item.truck && this.packet.trucksdict[item.truck]) {
                            driverSet.add(item.truck);
                        }
                    });

                    this.available_drivers = [
                        { value: null, text: 'ALL DRIVERS' },
                        ...Array.from(driverSet).map(driverKey => ({
                            value: driverKey,
                            text: this.packet.trucksdict[driverKey] || driverKey
                        })).sort((a, b) => a.text.localeCompare(b.text))
                    ];
                },
               updateAvailableLocations(filteredItems = null) {
    const itemsToUse = filteredItems || this.items;
    const pickFromSet = new Set();
    const deliveryLocationSet = new Set();

    itemsToUse.forEach(item => {
        // Get Item Pick From location
        const pickFromLocation = this.getItemPickFromLocation(item);
        if (pickFromLocation) {
            pickFromSet.add(pickFromLocation);
        }

        // Get Delivery Location (drop_locsub)
        const deliveryLocation = this.getDeliveryLocation(item);
        if (deliveryLocation) {
            deliveryLocationSet.add(deliveryLocation);
        }
    });

    // Update Item Pick From options
    this.available_pick_from_locations = [
        { value: null, text: 'ALL LOCATIONS' },
        ...Array.from(pickFromSet).map(location => ({
            value: location,
            text: location
        })).sort((a, b) => a.text.localeCompare(b.text))
    ];

    // Update Delivery Location options
    this.available_delivery_locations = [
        { value: null, text: 'ALL LOCATIONS' },
        ...Array.from(deliveryLocationSet).map(location => ({
            value: location,
            text: location
        })).sort((a, b) => a.text.localeCompare(b.text))
    ];
},
             updateAvailableOrderTypes(filteredItems = null) {
    const itemsToUse = filteredItems || this.items;
    const orderTypeCounts = {};

    itemsToUse.forEach(item => {
        let typeKey = '';
        let typeName = '';

        // Determine order type
        if (item.incoming_type === 'STORE_TRANSFER_ORDER') {
            typeKey = 'store_transfer';
            typeName = 'STORE TRANSFER';
        } else if (item.incoming_type === 'DAMAGE_ORDER') {
            typeKey = 'damage_order';
            typeName = 'DAMAGE ORDER';
        } else if (item.order_type === 'home_delivery') {
            typeKey = 'home_delivery';
            typeName = 'HOME DELIVERY';
        } else if (item.order_type === 'store_pickup') {
            typeKey = 'store_pickup';
            typeName = 'STORE PICKUP';
        } else {
            typeKey = item.order_type || item.incoming_type || 'unknown';
            typeName = typeKey.toUpperCase().replace(/_/g, ' ');
        }

        orderTypeCounts[typeKey] = (orderTypeCounts[typeKey] || 0) + 1;
    });

    this.available_order_types = [
        { value: null, text: 'ALL TYPES' },
        ...Object.keys(orderTypeCounts).map(orderType => {
            let displayText = '';
            switch(orderType) {
                case 'home_delivery':
                    displayText = 'HOME DELIVERY';
                    break;
                case 'store_pickup':
                    displayText = 'STORE PICKUP';
                    break;
                case 'store_transfer':
                    displayText = 'STORE TRANSFER';
                    break;
                case 'damage_order':
                    displayText = 'DAMAGE ORDER';
                    break;
                default:
                    displayText = orderType.toUpperCase().replace(/_/g, ' ');
            }
            return {
                value: orderType,
                text: `${displayText} (${orderTypeCounts[orderType]})`
            };
        })
    ];
},
            updateAvailableStatuses(filteredItems = null) {
        const itemsToUse = filteredItems || this.items;
        const statusCounts = {};

        // Count occurrences of each status value
        itemsToUse.forEach(item => {
            const statusValue = item.state;
            statusCounts[statusValue] = (statusCounts[statusValue] || 0) + 1;
        });

        // Create status options from your mappings, but only include statuses that exist in current data
        const availableStatusOptions = mappings.states
            .filter(state => statusCounts[state.value] !== undefined)
            .map(state => {
                // Apply your custom text mappings
                let statusText = state.text;
                if(state.value == 9) statusText = "RECEIVED FROM WAREHOUSE";
                if(state.value == 10) statusText = "DISPATCHED FOR STORE";
                if(state.value == -10) statusText = "CANT DISPATCHED FOR STORE";

                return {
                    value: state.value,
                    text: `${statusText} (${statusCounts[state.value]})`
                };
            });

        this.status_options = [
            { value: null, text: 'ALL STATUS' },
            ...availableStatusOptions
        ];
    },
                getFilteredStates(item) {
        const allowedStates = [9, 10, -10]; // RECEIVED, DISPATCHED, CANT DISPATCHED

        // If current state is one of the allowed states, show all allowed states
        if (allowedStates.includes(item.state)) {
            return this.states.filter(state => allowedStates.includes(state.value));
        } else {
            // If current state is NOT in allowed states, only show the current state
            const currentState = this.states.find(state => state.value === item.state);
            return currentState ? [currentState] : [];
        }
    },
        getStatusText(state) {
        const statusObj = this.status_options.find(opt => opt.value === state);
        return statusObj ? statusObj.text : "UNKNOWN";
    },
                getDriverKey(driverName) {
                    // Find the key in trucksdict that matches the driver name
                    for (const [key, value] of Object.entries(this.packet.trucksdict)) {
                        if (value === driverName) {
                            return key;
                        }
                    }
                    return driverName; // fallback
                },
                allowed: function(item){
                    let status = true
                    let allowed_item = this.allowed_item(item);
                    let filtered_location = this.filtered_location(item);
                    let filtered_pickup_truck = this.filtered_pickup_truck(item);

                    if (allowed_item && filtered_location && filtered_pickup_truck){
                        status = true
                    }
                    else {
                        status = false
                    }
                    return status
                },
     allowed_item: function(item){
    let status = true;
    let userrole = this.packet.userDetails.userrole;

    // Get the user's location ID
    let userLocationId = this.packet.userDetails.properties.location_id;

    if (userrole == "admin" || userrole == "officeuser") {
        status = true;
    }
    else {
        if (userLocationId) {
            // For DAMAGE_ORDER, check if the item belongs to user's location
            if (item.incoming_type === 'DAMAGE_ORDER') {
                // Check if drop_location matches user's location
                // You might need to adjust this based on your business logic
                let itemLocation = item.drop_location || item.drop_locsub.split('|')[0];
                status = parseInt(itemLocation) === parseInt(userLocationId);
            } else {
                // Existing logic for other order types
                let location_id = parseInt(userLocationId);
                // Add your existing location check logic here
            }
        }
        else {
            status = false;
        }
    }
    return status
},
            filtered_location: function(item){
        let status = true;
        if (this.picked_location_id) {
            // Check if either drop_locsub OR ship_locsub matches the picked location

            let shipLocMatches = item.ship_locsub && parseInt(item.ship_locsub) === parseInt(this.picked_location_id);

            status = shipLocMatches;
        }
        return status
    },
                filtered_pickup_truck: function(item){
                    let status = true;
                    if (this.picked_pickup_truck) {
                        if (item.pickup_truck == this.picked_pickup_truck){
                            status = true;
                        }
                        else {
                            status = false;
                        }
                    }
                    return status
                },
                show_comments: function(item){
                    this.item_comments_invoice_id = item.invoice_id;
                    this.item_comments_itemid= item.itemid;
                    this.$bvModal.show("modal-comments");
                },
            update_invoice_item_state: function(item){
                    let path = "/api/sales/update_invoice_item_state/"
                    let that = this;

                    //for now, do not process store transfer orders.
                    // if (item.incoming_type == 'STORE_TRANSFER_ORDER'){
                    //     return
                    // }

                    let data = {invoice_id: item.invoice_id, itemid: item.itemid, state: item.state, changed_by: this.packet.userDetails.username, product_sku: item.product_sku, quantity: item.quantity, incoming_type: item.incoming_type }

                    let s = function(response) {
                        if (response.data.error){
                            that.$bvToast.toast(
                                response.data.error,
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                        else {
                            that.$bvToast.toast(
                                "Success updating item state.",
                                {title: "Success", autoHideDelay: 1500, variant:"success"}
                            );
                        }
                    }

                    let f = function(error) {
                        console.log(error)
                        that.$bvToast.toast(
                            "Error updating item state.",
                            {title: "Error", autoHideDelay: 1500, variant:"danger"}
                        );
                    }
                    Requestor.postAsync(path, data, s, f);
                },
                get_items_for_date: function(date){
                    this.active_date = date.date;
                    let that = this;
                    let path = ""
                    if (this.type == 'incoming'){
                        path = "/api/sales/get_incoming_items/"
                    }
                    else {
                        path = "/api/sales/get_outgoing_items/"
                    }

                    if (!path){
                        return
                    }
                    let data = {locsub: this.locsub, date: date.date}
                    let s = function(response) {
                        if (response.data.result){
                            that.items = response.data.result;
                            that.updateAllAvailableOptions();
                        }
                        else {
                            that.$bvToast.toast(
                                response.data.error,
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                        that.items_being_loaded = false;
                        that.get_batch_comments();
                    }

                    let f = function(error) {
                        console.log(error)
                        that.$bvToast.toast(
                            "Error fetching items for the date.",
                            {title: "Error", autoHideDelay: 1500, variant:"danger"}
                        );
                        that.items_being_loaded = false;
                    }
                    this.items = [];
                    this.items_being_loaded = true;
                    Requestor.getSync(path, data, s, f);
                },
                get_batch_comments: function(){
                    let items = [];
                    for (var i =0; i<this.items.length; i++){
                        for (var j=0; j<this.items[i].items.length; j++){
                            items.push(
                                {
                                    invoice_id: this.items[i].items[j].invoice_id,
                                    itemid: this.items[i].items[j].itemid,
                                }
                            )
                        }
                    }
                    let path = "/api/sales/get_batch_comments/"
                    let data = {items: items};
                    let that = this;
                    let s = function(response){
                        if (response.data.result){
                            let comments = response.data.result;
                            if (comments.length > 0){
                                that.comments_dict = Object.assign({}, ...comments.map((x) => ({[x.invoice_id+'|'+x.itemid]: x.n_comments})));
                            }
                        }
                        else {
                            console.log(response.data.error)
                            that.$bvToast.toast(
                                response.data.error,
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                    }

                    let f = function(error){
                        that.$bvToast.toast(
                            "Error loading comments.",
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }

                    Requestor.postAsync(path, data, s, f);
                },
                fetch_init2: function(d){
                    let path = "/api/sales/get_incoming_items_for_date_range3/"
                    let that = this;
                    let data = {date_range: this.date_range.filter(d => d !== null), drop_location: this.drop_location};

                    if (!data.drop_location && this.packet.userDetails.properties && !this.packet.userDetails.properties.location_id){
                        this.$vex.dialog.alert({
                            message: "PICK AN INCOMING LOCATION"
                        });
                        return
                    }

                    let s = function(response) {
                        if (response.data.result){
                            that.items = response.data.result;
                            that.updateAllAvailableOptions();
                        }
                        else {
                            that.$bvToast.toast(
                                response.data.error,
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                        that.items_being_loaded = false;
                    }

                    let f = function(error) {
                        console.log(error)
                        that.$bvToast.toast(
                            "Error loading incoming items.",
                            {title: "Error", autoHideDelay: 1500, variant:"danger"}
                        );
                        that.items_being_loaded = false;
                    }

                    this.items_being_loaded = true;
                    this.items = [];
                    // Reset filters
                    this.selected_date = null;
                    this.selected_driver = null;
                    this.selected_order_type = null;
                    this.selected_pick_from = null;
                    this.selected_delivery_location = null;
                    this.selected_status = null;
                    Requestor.postSync(path, data, s, f);
                },
                get_incoming_items_for_date: function(){
                    let path = "/api/sales/get_incoming_items_for_date/"
                    let that = this;
                    let data = {date: this.picked_date};
                    let s = function(response) {
                        if (response.data.result){
                            that.items = response.data.result;
                            that.updateAllAvailableOptions();
                        }
                        else {
                            that.$bvToast.toast(
                                response.data.error,
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                        that.items_being_loaded = false;
                    }

                    let f = function(error) {
                        console.log(error)
                        that.$bvToast.toast(
                            "Error loading incoming items.",
                            {title: "Error", autoHideDelay: 1500, variant:"danger"}
                        );
                        that.items_being_loaded = false;
                    }

                    this.items_being_loaded = true;
                    this.items = [];
                    Requestor.postSync(path, data, s, f);
                },
                get_incoming_dates_for_year_month: function(){
                    let path = "/api/sales/get_incoming_dates_for_year_month/"
                    let that = this;
                    let data = {year: this.year, month: this.month};
                    if (this.packet.userDetails.properties.location_id){
                        data.location_id = this.packet.userDetails.properties.location_id;
                    }
                    let s = function(response) {
                        if (response.data.result){
                            that.dates = response.data.result;
                            that.dates = that.dates.map(function(d){
                                return {value: d.date, text: d.date + ' ('+d.nitems+')' }
                            });
                        }
                        else {
                            that.$bvToast.toast(
                                response.data.error,
                                {title: "Error", autoHideDelay: 1500, variant:"warning"}
                            );
                        }
                        that.dates_being_loaded = false;
                    }

                    let f = function(error) {
                        console.log(error)
                        that.$bvToast.toast(
                            "Error loading incoming dates.",
                            {title: "Error", autoHideDelay: 1500, variant:"danger"}
                        );
                        that.dates_being_loaded = false;
                    }

                    this.dates = [];
                    this.items = [];
                    this.picked_date = null;
                    this.picked_location = null;
                    Requestor.postAsync(path, data, s, f);
                },
                fetch_prereqs: function(){
                },
                fetch: function(type){
                    this.type = type;
                    this.items = []
                    this.dates = []
                    this.active_date = null;
                    this.locsub = null;
                },
                sortby: function(key,mapper){
                    if (this.sort_asc){
                        this.items = Requestor.sort(this.items,key,mapper)
                    }
                    else {
                        this.items = Requestor.sort_reverse(this.items,key,mapper)
                    }
                    this.sort_asc = !this.sort_asc;
                },
                set_dates: function(value){
                    let start = null;
                    let end = null;

                    if(value == 'today') {
                        start = moment().format("MM-DD-YYYY");
                        end = moment().format("MM-DD-YYYY");
                    }
                    if(value == 'yesterday') {
                        start = moment().add(-1, 'days').format("MM-DD-YYYY");
                        end = moment().add(-1, 'days').format("MM-DD-YYYY");
                    }
                    if(value == 'this_week') {
                        start = moment().startOf('week').format("MM-DD-YYYY");
                        end = moment().endOf('week').format("MM-DD-YYYY");
                    }
                    if(value == 'last_week') {
                        start = moment().subtract(1, 'weeks').startOf('week').format("MM-DD-YYYY");
                        end = moment().subtract(1, 'weeks').endOf('week').format("MM-DD-YYYY");
                    }
                    if(value == 'this_month') {
                        start = moment().startOf('month').format("MM-DD-YYYY");
                        end = moment().endOf('month').format("MM-DD-YYYY");
                    }
                    if(value == 'last_month') {
                        start = moment().subtract(1, 'months').startOf('month').format("MM-DD-YYYY");
                        end = moment().subtract(1, 'months').endOf('month').format("MM-DD-YYYY");
                    }

                    if (start && end) {
                        this.date_range = [start , end]
                        this.picked_date_range = value;
                    }
                },
    get_locations: function(){
        let output = [
            {value: null, text: "PICK LOCATION", disabled: true}
        ];

        if (this.packet.locations) {
            // Filter out the unwanted locations
            let filteredLocations = this.packet.locations.filter(location => {
                const locationText = location.text ? location.text.toUpperCase() : '';
                return !locationText.includes('OUT OF STOCK') &&
                    !locationText.includes('ONLINE SALES')
                    //    !locationText.includes('ALL');
            });

            output = output.concat(filteredLocations);
        }

        return output;
    }
            },
            mounted: function() {
              this.handleResize();
              window.addEventListener('resize', this.handleResize);
            },
            beforeDestroy() {
              window.removeEventListener('resize', this.handleResize);
            },
            created: function(){
                this.packet = JSON.parse(localStorage.packet);
                this.packet.userDetails = JSON.parse(localStorage.userDetails);
                this.trucks = this.packet.trucks;

                if (this.packet.userDetails.properties && this.packet.userDetails.properties.location_id) {
                    let userLocation = this.packet.locations.find(item => [this.packet.userDetails.properties.location_id].includes(item.value))
                    if (userLocation) {
                        this.drop_location = userLocation.value
                        this.fetch_init2();
                    }
                };
            }
        }
    </script>

    <style scoped>
    .diver {
        overflow: auto;
        width: 100%;
        height: 800px;
    }
    .srr {
        font-size: 12px;
        text-align: center;
        font-weight: bold;
        background: rgb(60, 60, 60);
        color: white;
        border: 1px solid #ffffff;
    }

    .srrv {
        font-size: 13px;
        text-align: center;
        background: white;
        border: 1px solid #010101;
        padding: 5px;
    }
    table {
        table-layout: fixed;
        width: 100%;
    }
        .ipt_tdr {
            background: none;
            text-align: center;
            font-size: 12px;
        }

        .ipt_tdhr {
            background: #343a40;
            color: white;
            font-weight: bold;
            text-align: center;
            font-size: 12px;
            border: 1px solid white;
        }

    @media (max-width: 768px) {
        .diver {
            height: auto;
            overflow-x: auto;
            overflow-y: auto;
        }
    }
    </style>



// WEBPACK FOOTER //
// src/components/Shipping/ShippingOrders.vue